export function formatTime(time) {
  const [hours, minutes] = time.toString().split(".");
  const paddedMinutes = minutes ? minutes.padEnd(2, "0") : "00";
  return `${hours}:${paddedMinutes}`;
}
